import React, { useState } from 'react'
import AddNewPastSurgeries from './AddNewPastSurgeries';

const PastSurgeries = ({ data: pastSurgeriesData, setIsRecordSaved, patientID, ...props}) => {

  let { isViewAllowed, IsEditAllowed , IsDeleteAllowed} = props;
  const [isOpenPastSurgeries, setIsOpenPastSurgeries] = useState(false);
  const [pastSurgeryData, setPastSurgeryData] = useState();
  // const [pastSurgeriesData, setPastSurgeriesData] = useState([]);
  const [expandItems, setExpandItems] = useState(true);

  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }


  const AddPastSurgeries = (item) => {
    if(!isViewAllowed) return;
    setPastSurgeryData(item)
    setIsOpenPastSurgeries(prev => !prev);
  }
  const ClosePastSurgeries = () => {
    setIsOpenPastSurgeries(false)
  }

  let PopupScreen = "";
  if (isOpenPastSurgeries) {
    PopupScreen = <AddNewPastSurgeries isOpenPastSurgeries={isOpenPastSurgeries} pastSurgeryData={pastSurgeryData} setPastSurgeryData={setPastSurgeryData} setIsRecordSaved={setIsRecordSaved} onClose={ClosePastSurgeries} patientID={patientID} // onDeletePastSurgeries={DeletePastSurgeries} 
    IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}
    />
  }
  return (
    <>
      {PopupScreen}
      <div className='mb-2'>
        <div className="d-flex justify-content-between align-items-center mb-1 mx-2">
          <p className='cursor-pointer user-select-none heading' onClick={handleToggleExpand}>Past Surgeries</p>
          <div className={`ar-add-icon ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddPastSurgeries({ PatientHistoryID: null })}>
            <i className="icon-dash-plus"></i>
          </div>
        </div>
        <div className="d-flex flex-column gap-1 problem-scroll px-2">
          
          {expandItems &&
          (pastSurgeriesData?.length > 0 ?
            pastSurgeriesData.map(item => (
              <div className='ar-dot'>
                <p className={`multiline-ellipsis  text ar-hover-text validation_message ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddPastSurgeries(item)}>{item.Notes}</p>
              </div>
            )) :
            <p className="text C9-light-clr fst-italic">No past surgeries recorded</p>)}
        </div>
      </div>
    </>
  )
}

export default PastSurgeries